import * as K from './QuotationsConstants';
import immutable from 'object-path-immutable';
import auth from '../../../libCustom/auth';
import moment from 'moment';

export const init = {
  loading: false,
  search: '',
  data: [],
  searchData: null,
  table: {
    page: 0,
    sorted: [],
    filtered: [],
    pageSize: undefined,
  },
  status: '',
  clientInformation: {
    clientId: '',
    firstName: '',
    phone: '',
    email: '',
    notes: '',
    type: '',
  },
  previousQuotes: [
    {
      destinationCity: 'Ixtapa',
      datetimeDeparture: '09/03/2018 12:00 hrs',
      status: 'Lograda',
    },
    {
      destinationCity: 'San Miguel de Allende',
      datetimeDeparture: '08/08/2017 15:00 hrs',
      status: 'Lograda',
    },
  ],
  assignedTo: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
  comments: '',
  formDataMessages: [],
  formDataSend: {},
  dates: {
    departureDate: moment(),
    returnDate: moment(),
    openDate: false,
    duration: '',
  },
  flightsId: '',
  flights: [],
  generalQuotation: {
    userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    validDate: '',
    destination: '',
    interest: '',
    adults: '',
    juniors: '',
    kids: '',
    notes: '',
    assignedTo: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
    executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
    group: false,
    down: false,
    status: 'leats',
  },
  optionsSelect: {
    users: [],
    clients: [],
  },
  otherServicesQuotation: [
    /* {
      name: 'Paracaidismo',
      description:
        'Incluye un video de aprox. 5 min desde el momento de subir al avión hasta el momento de tu aterrizaje, con hermosas tomas de tu vuelo sobre la zona ya con tu paracaídas abierto, clips de video originales, se entregan minimo 100 fotos (caída libre y descenso).',
      price: '3455.00',
      buyprice: '2500.00',
      operator: {
        label: 'Megatravel',
        id: ''
      },
      selected: true
    }*/
  ],
  packages: [],
  lodgings: [],
  formData: {},
  dataToEdit: {
    flight: {},
    otherServices: {},
    lodging: {},
    packages: {},
  },
  indexToEdit: '',
  modalAddStatus: {
    flight: false,
    otherServices: false,
    packages: false,
  },
  ordenGenerated: '',
  dateSended: moment(),
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case K.SETSTATE: {
      return action.payload;
    }

    case K.STATEINIT: {
      return init;
    }

    case K.ON_CHANGE: {
      return immutable.set(state, action.payload.path, action.payload.value);
    }
    case K.ADD_SERVICE: {
      return immutable.push(state, ['otherServicesQuotation'], action.payload);
    }

    case K.UPDATE_SERVICE: {
      return immutable.set(
        state,
        ['otherServicesQuotation', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_PACKAGE: {
      return immutable.push(state, ['packages'], action.payload);
    }

    case K.UPDATE_PACKAGE: {
      return immutable.set(
        state,
        ['packages', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_FLIGHT: {
      return immutable.push(state, ['flights'], action.payload);
    }

    case K.UPDATE_FLIGHT: {
      return immutable.set(
        state,
        ['flights', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.ADD_LODGING: {
      return immutable.push(state, ['lodgings'], action.payload);
    }

    case K.UPDATE_LODGING: {
      return immutable.set(
        state,
        ['lodgings', action.payload.data.index],
        action.payload.data.value
      );
    }

    case K.LOADING: {
      return { ...state, loading: true };
    }

    case K.LOADED: {
      return { ...state, loading: false };
    }

    case K.OPEN_MODAL_ADD: {
      return immutable.set(state, ['modalAddStatus', action.payload], true);
    }

    case K.CLOSE_MODAL_ADD: {
      var newState = immutable.set(
        state,
        ['modalAddStatus', action.payload],
        false
      );
      newState = immutable.set(newState, ['dataToEdit', action.payload], {});
      return newState;
    }

    case K.FIND + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.FIND + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        formData: {},
      };
    }

    case K.FIND + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        formData: {},
        error: action.payload,
      };
    }

    //GET CLIENT

    case K.FIND_BY_ID + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.FIND_BY_ID + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: action.payload,
      };
    }

    case K.FIND_BY_ID + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //CREATE

    case K.CREATE + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.CREATE + '_FULFILLED': {
      return {
        ...state,
        search: '',
        loading: false,
        loaded: true,
        formData: init.formData,
        openForm: false,
      };
    }

    case K.CREATE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //UPADTE

    case K.UPDATE + '_PENDING': {
      return { ...state, loading: true, formData: action.payload };
    }

    case K.UPDATE + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: init.formData,
      };
    }

    case K.UPDATE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    //DELETE

    case K.DELETE + '_PENDING': {
      return { ...state, loading: true };
    }

    case K.DELETE + '_FULFILLED': {
      return {
        ...state,
        loading: false,
        loaded: true,
        formData: init.formData,
      };
    }

    case K.DELETE + '_REJECTED': {
      return {
        ...state,
        loading: false,
        loaded: false,
        formData: init.formData,
        error: action.payload,
      };
    }

    case K.CHANGE_TABLE: {
      return {
        ...state,
        table: {
          ...state.table,
          [action.payload.feature]: action.payload.value,
        },
      };
    }

    case K.SEARCH_TABLE: {
      return {
        ...state,
        searchData:
          action.payload.search !== '' ? action.payload.searchData : null,
        search: action.payload.search,
      };
    }

    default:
      /* code */
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/views/Quotations/redux/QuotationsReducers.jsx